import React, { useContext,useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row, Container } from "react-bootstrap";
import Select from "react-select";
import schoolApi from "../../api/schoolApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
//import { SessionContext } from "../SessionProvider";

const VehicleUpdate = ({
  show,
  onHide,
  onSuccess,
  selectedVehicle,
  onUpdateRec,
}) => {

 
  const id = selectedVehicle.id;
  const [formData, setFormData] = useState({
    driver_id: null,
    vehicle_no: "",
    type: "",
    seating_capacity: "",
    status: "Active",
    end_point: null,
  });
  //const { selectedSessionId, setSelectedSessionId } = useContext(SessionContext);
  const [driverOptions, setDriverOptions] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [sessionYear, setSessionYear] = useState([]);

  useEffect(() => {
    async function getSessions() {
      try {
        const sessions = await schoolApi.fetchSessions();
        console.log("sessions data == ",sessions)
        if (sessions.success) {
          setSessionYear(sessions.result);
        } else {
          setSessionYear([]);
        }
      } catch (err) {
        toast.error("An error occurred while fetching sessions.");
        setSessionYear([]);
      }
    }
    getSessions();
  }, []);
  useEffect(() => {
    if (selectedVehicle) {
      setFormData({
        driver_id: {
          value: selectedVehicle.driver_id || "",
          label: selectedVehicle.driver_name || "",
        },
        vehicle_no: selectedVehicle.vehicle_no || "",
        type: selectedVehicle.type || "",
        seating_capacity: selectedVehicle.seating_capacity || "",
        status: selectedVehicle.status || "",
        end_point: {
          value: selectedVehicle.end_point || "",
          label: selectedVehicle.location_name || "",
        },
        session_id : selectedVehicle?.session_id,
      });
    }
  }, [selectedVehicle]);
 

  useEffect(() => {
    async function fetchDrivers() {
      try {
        const drivers = await schoolApi.fetchDrivers();
       
        if (drivers.success) {
          const driverOptions = drivers.drivers.map((driver) => ({

            value: driver.id,
            label: driver.firstname,
          }));
          driverOptions.unshift({ value: "", label: "Select Driver" });
          setDriverOptions(driverOptions);
        }
      } catch (error) {
        console.error("Error fetching drivers:", error);
        setDriverOptions([]);
        return;

      }
    }

    fetchDrivers();
  }, []);

  useEffect(() => {
    async function fetchLocations() {
      try {
        const locations = await schoolApi.getAllLocation();
       
        if (locations.success) {
          const locationOptions = locations.result.map((location) => ({
            value: location.id,
            label: location.location,
          }));
          locationOptions.unshift({ value: "", label: "Select End Point" });
          setLocationOptions(locationOptions);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
        return toast.error(error.response.data.message);
      }
    }

    fetchLocations();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
   
   console.log("before update == ",formData)

    if (formData.type.trim() === "" || formData.vehicle_no.trim() === "" || formData.session_id.trim() === "" || !formData.status ) {
      toast.error("Missing required fields");
      return;
    }

    try {
      const result = await schoolApi.updateVehicle(id, {
        driver_id: formData.driver_id.value
          ? formData.driver_id.value
          : formData.driver_id,
        vehicle_no: formData.vehicle_no,
        type: formData.type,
        seating_capacity: formData.seating_capacity,
        status: formData.status,
        end_point: formData.end_point.value
          ? formData.end_point.value
          : formData.end_point,
        session_id : formData.session_id
      });
     
      if (result.success) {
      console.log("after update == ",result)
        toast.success(result.message);
        onSuccess();
        onHide();
        onUpdateRec();
      }
    } catch (error) {
     
      return toast.error(error.response.data.message);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  console.log('update-formdata-->>>' , formData);

  return (
    <Modal
      show={show}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title>Update Vehicle</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="view-form">
          <Form onSubmit={handleSubmit} noValidate>
            <Row>
              <Col lg={6}>
                <Form.Group>
                  <Form.Label>Vehicle Type</Form.Label>
                  <Form.Select
                    required
                    placeholder="Select Driver"
                    name="type"
                    value={formData.type}
                    onChange={handleChange}
                  >
                    <option value="">-- Select --</option>
                    <option value="bus">Bus</option>
                    <option value="van">Van</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col lg={6}>
                {console.log("sh code driver == ", formData.driver_id)}
                <Form.Group>
                  <Form.Label>Vehicle Driver</Form.Label>
                  <Form.Select
                    placeholder="Select Driver"
                    name="driver_id"
                    onChange={handleChange}
                    value={
                      formData.driver_id?.value !== ""
                        ? formData.driver_id?.value
                        : formData.driver_id
                    }
                  >
                    {}
                    {driverOptions.map((res) => (
                      <option key={res.value} value={res.value}>
                        {res.label ? res.label : formData.driver_id}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <Form.Group>
                  <Form.Label>Vehicle Number</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    name="vehicle_no"
                    placeholder="Enter Vehicle Number"
                    value={formData.vehicle_no}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group>
                  <Form.Label>End Point</Form.Label>
                  <Form.Select
                    placeholder="Select End point"
                    name="end_point"
                    onChange={handleChange}
                    value={
                      formData.end_point?.value !== ""
                        ? formData.end_point?.value
                        : formData.end_point
                    }
                  >
                    {locationOptions.map((res) => (
                      <option key={res.value} value={res.value}>
                        {res.label ? res.label : formData.end_point}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <Form.Group>
                  <Form.Label>Vehicle Capacity</Form.Label>
                  <Form.Control
                    type="phone"
                    name="seating_capacity"
                    placeholder="Vehicle Capacity"
                    value={formData.seating_capacity}

                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        seating_capacity: e.target.value.replace(/\D/g, ""),
                      })
                    }
                  />
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group>
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    name="Status"
                    value={formData.status}
                    required
                    onChange={(e) =>
                      setFormData({ ...formData, status: e.target.value })
                    }

                  >
                    <option value="">--select status--</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">InActive</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group>
                  <Form.Label
                    className="form-view-label"
                    htmlFor="formBasicSession"
                  >
                    Session
                  </Form.Label>
                  <Form.Select
                    required
                    name="session_id"
                    value={formData.session_id}
                    onChange={handleChange}
                    disabled="true"
                  >
                    <option value="">-- Select Session --</option>
                    {sessionYear.map((session) => (
                      <option key={session.id} value={session.id}>
                        {session.year}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            onHide();
          }}
        >
          Cancel
        </Button>
        <Button variant="primary" type="submit" onClick={handleSubmit}>
          Update
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default VehicleUpdate;
